import React from "react";

function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#1A1A1A"
        d="M23.364 20.897c.673.748.673 1.87 0 2.542-.747.748-1.869.748-2.542 0L12 14.542 3.103 23.44c-.748.748-1.87.748-2.542 0-.748-.673-.748-1.794 0-2.542L9.458 12 .56 3.103c-.748-.748-.748-1.87 0-2.542a1.637 1.637 0 012.467 0L12 9.533 20.897.636a1.637 1.637 0 012.468 0c.747.672.747 1.794 0 2.542L14.466 12l8.897 8.897z"
      ></path>
    </svg>
  );
}

export default React.memo(CloseIcon);
